import { z } from 'zod'
import { type ServerActionResponse } from './types'

export enum ChannelOptions {
  WalkIn = 'WALK_IN',
  Telephone = 'TELEPHONE',
  Grassroots = 'GRASSROOTS',
  PaidSocial = 'PAID_SOCIAL',
}

export type AddNewLeadResponse = ServerActionResponse<NewLeadData>

export const NewLeadSchema = z.object({
  firstName: z.string().min(1, { message: 'First name is required.' }),
  lastName: z.string().min(1, { message: 'Last name is required.' }),
  email: z.email({ message: 'Invalid email address.' }),
  phone: z.string().min(12, {
    message:
      'Phone number must be at least 12 characters including country code.',
  }),
  channel: z.enum(ChannelOptions, {
    message: 'Channel must be Walk In, Telephone, Grassroots, or Paid Social.',
  }),
})

export type NewLeadData = z.infer<typeof NewLeadSchema>
